'use client';

import type { ReactNode } from 'react';
import { useEffect, useRef, useState } from 'react';

interface UseBottomCTAAnimationParams {
  isHidden: boolean;
  toastContent?: ReactNode;
}

export const useBottomCTAAnimation = ({
  isHidden,
  toastContent,
}: UseBottomCTAAnimationParams) => {
  const [isBottomVisible, setIsBottomVisible] = useState(false);
  const [isToastVisible, setIsToastVisible] = useState(false);
  const lastToastContent = useRef<ReactNode>(null);

  if (toastContent) lastToastContent.current = toastContent;

  useEffect(() => {
    if (!isHidden) {
      const bottomTimer = setTimeout(() => {
        setIsBottomVisible(true);
      }, 100);

      const toastTimer = setTimeout(() => {
        setIsToastVisible(true);
      }, 400);

      return () => {
        clearTimeout(bottomTimer);
        clearTimeout(toastTimer);
      };
    } else {
      setIsToastVisible(false);
      const hideTimer = setTimeout(() => {
        setIsBottomVisible(false);
      }, 150);

      return () => clearTimeout(hideTimer);
    }
  }, [isHidden]);

  return {
    isBottomVisible,
    isToastActive: isToastVisible && !!toastContent,
    displayToastContent: toastContent ?? lastToastContent.current,
  };
};
